import { render, staticRenderFns } from "./TemplatesCMS.vue?vue&type=template&id=2d88a610&scoped=true&"
import script from "./TemplatesCMS.vue?vue&type=script&lang=js&"
export * from "./TemplatesCMS.vue?vue&type=script&lang=js&"
import style0 from "./TemplatesCMS.vue?vue&type=style&index=0&id=2d88a610&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d88a610",
  null
  
)

export default component.exports